import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import styled from "styled-components";
import { WHEN_LG, WHEN_MD, WHEN_XL } from "../constants";
import ContentContainer from "./ContentContainer";

const OuterContainer = styled(ContentContainer)`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  overflow: hidden;

  ${WHEN_MD} {
    flex-direction: row;
    align-items: flex-start;
    padding-top: 3rem;
  }
`;
const InnerLeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 3rem;
  flex: 1;

  ${WHEN_MD} {
    margin: 0;
  }
  ${WHEN_LG} {
    padding-top: 8rem;
  }
`;
const InnerRightContainer = styled.div`
  height: 100%;
  flex: 1;
  width: 170%;
  position: relative;

  ${WHEN_MD} {
    width: 100%;
    margin-top: -3rem;
    margin-right: -4rem;
  }
`;

const HeroHeading = styled.h1`
  position: relative;
  width: 100%;

  font-size: 42px;
  ${WHEN_MD} {
    font-size: 52px;
  }
  ${WHEN_LG} {
    font-size: 60px;
  }
  ${WHEN_XL} {
    font-size: 74px;
  }
`;

const HeroTextContainer = styled.div`
  width: 100%;
  ${WHEN_XL} {
    max-width: 700px;
  }
`;

const HeroSubheading = styled.p`
  width: 100%;
  font-size: 20px;

  ${WHEN_LG} {
    font-size: 20px;
  }
  ${WHEN_XL} {
    font-size: 24px;
  }
`;

const VideoContainer = styled.div`
  width: 45.2%;
  height: 38.4%;
  top: 12.3%;
  left: 27.4%;
  position: absolute;
  overflow: hidden;

  ${WHEN_MD} {
    width: 67%;
    height: 45%;
    top: 29%;
    left: 20.3%;
  }
`;
const VideoContainerInner = styled.div`
  width: 114%;
  height: 130%;
  margin-left: -7%;
  margin-top: -10%;
`;

export default function HeroSection() {
  return (
    <div>
      <OuterContainer>
        <InnerLeftContainer>
          <HeroTextContainer>
            <HeroHeading>Run Your Finances on Notion</HeroHeading>
            <HeroSubheading>
              Transform your workspace into a powerful financial hub with
              real-time data sync
            </HeroSubheading>
            <button
              onClick={() => window.open("https://app.nofi.so", "_blank")}
              className="btn btn-primary btn--lg hide-md-block mt-4"
            >
              Get Started
            </button>
            <button
              onClick={() => window.open("https://app.nofi.so", "_blank")}
              className="btn btn-primary btn--md sm-only-block"
            >
              Get Started
            </button>
          </HeroTextContainer>
        </InnerLeftContainer>
        <InnerRightContainer>
          <StaticImage
            key="hero"
            className="hide-md-block"
            src="../images/hero-video-frame.svg"
            alt="demo video"
            placeholder="blurred"
            layout="fullWidth"
            style={{ maxWidth: 779, maxHeight: 726, objectFit: "contain" }}
          />
          <StaticImage
            key="hero-mobile"
            className="sm-only-block"
            src="../images/hero-video-frame-mobile.svg"
            alt="demo video"
            placeholder="blurred"
            layout="fullWidth"
            style={{
              objectFit: "contain",
            }}
          />
          <VideoContainer>
            <VideoContainerInner>
              <iframe
                style={{ width: "100%", height: "100%" }}
                src="https://www.youtube.com/embed/yGQZwLDPf5s?controls=0&autoplay=1&mute=1&playlist=yGQZwLDPf5s&loop=1&color=white&disablekb=1"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </VideoContainerInner>
          </VideoContainer>
        </InnerRightContainer>
      </OuterContainer>
    </div>
  );
}
